import React from 'react';
import { inject } from 'mobx-react';
import { mergeStyleSets, FontSizes, FontWeights, PrimaryButton } from '@fluentui/react';

import { BRAND_NAVATAR } from 'src/constants';
import MainLogo from '@v2/components/base/MainLogo';
import { useBrandedLogos } from 'src/brands';

const classNames = mergeStyleSets({
    root: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        selectors: {
            '& > p': {
                textAlign: 'center',
                margin: '8px 16px',
            },
        },
    },
    title: {
        fontSize: FontSizes.xxLarge,
        fontWeight: FontWeights.light,
    },
    maintenanceTitle: {
        fontSize: FontSizes.large,
        fontWeight: FontWeights.semibold,
        textAlign: 'center',
        margin: '20px 0 8px 0',
    },
    reloadButton: {
        margin: '20px auto 0 auto',
        maxWidth: '200px',
    }
})

const Maintenance = ({ userStore }) => {
    const { brand } = userStore || {};
    const { mainLogo } = useBrandedLogos();

    const handleReload = () => {
        window.location.reload();
    };

    return (
        <div className={classNames.root}>
            <MainLogo logo={mainLogo}>

                {brand !== BRAND_NAVATAR &&
                    <>
                        <div className={classNames.title}>XL-Connector 365</div>
                        <p>Copyright 2015-2026 © Xappex</p>
                        <p className={classNames.maintenanceTitle}>Maintenance in Progress</p>
                    </>
                }

                {brand === BRAND_NAVATAR &&
                    <>
                        <div className={classNames.title}>Navatar Excel Connect 365</div>
                    </>
                }
            </MainLogo>

            {brand !== BRAND_NAVATAR &&
                <p>We are currently performing system updates. The add-in will be available soon.</p>
            }

            {brand === BRAND_NAVATAR &&
                <p>We are currently performing system updates. The add-in will be available soon.</p>
            }
            <p>Thank you for your patience!</p>

            <p>You can refresh this page after a few minutes to check if the maintenance is complete.</p>

            <PrimaryButton
                text="Refresh Page"
                onClick={handleReload}
                className={classNames.reloadButton}
            />

        </div>
    )
}

export default inject('userStore')(Maintenance);
